import { render, staticRenderFns } from "./CapturaDocumentoFrente.vue?vue&type=template&id=0ce398ac&scoped=true&"
import script from "./CapturaDocumentoFrente.vue?vue&type=script&lang=js&"
export * from "./CapturaDocumentoFrente.vue?vue&type=script&lang=js&"
import style0 from "./CapturaDocumentoFrente.vue?vue&type=style&index=0&id=0ce398ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce398ac",
  null
  
)

export default component.exports